import { Loader } from '@hologram-dimension/loader';
import FullScreenModal from 'common-js/components/full-screen-modal';
import { type FC } from 'react';
import SkeletonSidebar from './SkeletonSidebar';

interface LoadingScreenProps {
  title?: string;
  content?: string;
}

const LoadingScreen: FC<LoadingScreenProps> = ({ title = 'Loading', content }) => (
  <FullScreenModal showProgress={false} title={title} sidebar={<SkeletonSidebar />}>
    <Loader className="LoadingScreen">{`Hang tight!${content && ` ${content}`}`}</Loader>
  </FullScreenModal>
);

export default LoadingScreen;
